<template>
  <div class="fill-height d-flex flex-column justify-center align-center">
    <div>
      <div class="text-center">
        <v-progress-circular
            indeterminate
            color="primary"
        ></v-progress-circular>
      </div>
      <div class="text-center mt-3">{{$t('loginComponent.preparing')}}</div>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
import EventsMixins from "@/mixins/EventsMixins";
import {loginReturnTarget} from "@/router/loginReturn";

export default {
  mixins: [EventsMixins],
  mounted() {
    if (this.$route.query.token) {
      this.$store.dispatch("logout", false);
      this.$store.commit("SET_TOKEN", {
        key: "token",
        data: this.$route.query.token,
      });
      localStorage.setItem("token", this.$route.query.token);
      this.$store.commit("SET_LOGIN");

      this.requesting("auth", "getProfile").then(() => {
        this.WebengageSetUserLoggedIn(this.$store.getters.getProfile.id);
        const returnTarget = loginReturnTarget(this.$route, this.$router);
        if (returnTarget) {
          this.$router.replace(returnTarget);
          return;
        }
        if (
            this.$route.query.callback &&
            this.$route.query.callback == "onboarding_presession"
        ) {
          this.$router.push({name: "preorder", params: {orderId: 197}});
        } else if (this.$route.query.redirect) {
          this.$router.push({
            name: this.$route.query.redirect,
            params: {lang: "fa"},
          });
          return;
        } else {
          let lang = 'fa'
          if (this.$route.query.lang) {
            lang = this.$route.query.lang
          }
          this.$router.push({
            name: this.$route.query.callback || 'dashboard',
            params: {lang: lang},
          });
        }
      });
    } else {
      this.$router.push({name: "login", params: {lang: "fa"}});
    }
  },
};
</script>

<style scoped></style>
